import React from 'react'
import AlertaDeInformacao from './AlertaDeInformacao'
import AlertaImprimirNotaFiscal from './AlertaImprimirNotaFiscal'

export const AlertaPedidoMarketplaceOut = ({ newPrintReceipt, order }) => {
    if (newPrintReceipt) {
        return <AlertaDeInformacao
            title="Confira se o formulário do pedido foi colocado junto ao pacote."
            body="Para que o cliente possa consultar a nota fiscal é necessário imprimir o formulário do pedido com o QR Code e grampeá-lo junto ao pacote."
        />
    }

    return (
        <AlertaImprimirNotaFiscal
            canalDeVendas={order.canalDeVendas}
            notaFiscal={order.notaFiscal}
            idPedido={order.codigoExterno}
        />
    )
}
